import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'v2-card-footer',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        display: block;
        padding: 16px 16px 25px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2CardFooter {}
